<!-- List picked Dates -->
<div *ngIf="serviceData?.length > 0" style="font-size: medium; font-weight: 500;" fxLayoutAlign="start center">
    {{"booking_details"|translate}}:</div>
<mat-divider style="border: 1px solid lightgray;"></mat-divider>
<div fxLayout="column" fxLayoutAlign="start start">
    <div *ngFor="let data of serviceData">
        <div class="row">
            <div class="dropcart__product-meta">
                @if (data.amount && data.amount > 1 && !(data.times?.length && timeType!='no_time')) {
                    <span  class="dropcart__product-quantity">{{ data.amount }}</span> ×
                }
               
                <span *ngIf="data.date">{{ data.date | date}}</span>
                <span class="mx-2" style="font-size: smaller;" *ngIf="data.startDate">{{"start_date"|translate}}:
                    {{data.startDate|date}}</span>
                <span class="mx-2" style="font-size: smaller;" *ngIf="data.endDate">{{"end_date"|translate}}:
                    {{data.endDate|date}}</span>
                <span class="mx-2" style="font-size: smaller;" *ngIf="data.time">{{"time"|translate}}: {{data.time
                    |date:'mediumTime'}}</span>
                <span class="mx-2" style="font-size: smaller;" *ngIf="data.start">{{"from"|translate}}:
                    {{data.start|date:'short'}}</span>
                <span class="mx-2" style="font-size: smaller;" *ngIf="data.end">{{"to"|translate}}: {{data.end
                    |date:'short'}}</span>
                <span class="mx-2" style="font-size: smaller;" *ngIf="data.time">Hours: {{data.hours}}</span>
            </div>
        </div>
        <div class="row" *ngIf="data.times?.length && timeType!='no_time'">
            <span style="font-size: smaller; font-weight: 500;">{{timeType=="time_range"?"Time":"TimeSlots"}}:</span>
            <span *ngFor="let timeslot of data.times" class="mx-2" style="font-size: smaller;">Start: {{timeslot.start
                |date:'mediumTime'}} - End: {{timeslot.end |date:'mediumTime'}} x{{timeslot.amount}}</span>
        </div>
        <mat-divider style="border: 1px solid lightgray;"></mat-divider>
    </div>
</div>